import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-400" data-id="element-45">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8 text-center text-sm" data-id="element-46">
        Global footprint: India • USA • UAE • Nigeria • Australia
      </div>
    </footer>;
}